export default "__VITE_ASSET__CtMmcXvm__"